<template>
  <!--  <div>-->
  <!--    <datetime v-model="date" input-id="startDate">-->
  <!--    </datetime>-->
  <!--  </div>-->
  <div class="container background-white">
    <notifications position="top center" ></notifications>

    <h3>Event for: {{this.campaignName}}</h3>
    <br>
    <div class="row">
      <div class="col-md-8 form-group required"><label for="title" class="control-label">Title</label>
        <input type="text" v-model="form.title" id="title" class="form-control required">
      </div>
    </div>

      <div class="row">
        <div class="col-md-8 form-group"><b>Event Type</b>
          <div><select name="day_selection" class="form-control select-day" v-model="day_selection">
            <option value="single">Single Day</option>
            <option value="multiple">Multiple Day</option>
          </select></div>
        </div>
      </div>

      <div class="row ">
        <div class="col-md-8 form-group  required">
          <label class="control-label required">Start Date</label>
<!--          <datetime-->
<!--              type="datetime"-->
<!--              v-model="form.begins_at"-->
<!--              input-class="col-md-8"-->
<!--              value-zone="UTC"-->
<!--              zone="UTC"-->
<!--              :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'}"-->
<!--              :phrases="{ok: 'Ok', cancel: 'Exit'}"-->
<!--              :hour-step="1"-->
<!--              :minute-step="15"-->
<!--              :week-start="7"-->
<!--              use12-hour-->
<!--              auto-->
<!--              class="theme-blue"-->
<!--          ></datetime>-->
        </div>
      </div>

      <div class="row" v-if="day_selection=='multiple'">
        <div class="col-md-8 form-group required">
          <label class="control-label">End Date</label>
<!--          <datetime input-class="col-md-8" v-model="form.end_date"/>-->
        </div>

      </div>

    <div class="row">
      <div class="col-md-8 form-group required">
        <label  class="control-label required">Address</label>
<!--        <vue-google-autocomplete-->
<!--            :value="form.fullAddress"-->
<!--            id="startLocationField"-->
<!--            classname="form-control"-->
<!--            placeholder="Enter address"-->
<!--            v-on:placechanged="getAddressData"-->
<!--            v-on:keypress="resetAddressOnKeyPress"-->
<!--            country="us"-->
<!--        />-->
      </div>
    </div>

      <a @click="createOrUpdate" class="btn btn-success" style="color: #fff"><i class="fa fa-check"></i> Save</a>
      <a v-if="campaignEventId" :href="eventsUrl()" class="btn btn-danger"><i class="fa fa-ban"></i> Cancel</a>
  </div>
</template>


<script>
// import {Datetime} from 'vue-datetime'
// import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'AddCampaignEventButton',
  props: {
    campaignId: null,
    campaignEventId: null,
    campaignName: null,
  },
  data() {
    return {
      day_selection: 'single',
      isOpen: false,
      form: {
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        description: null,
        begins_at: null,
        end_date: null,
        campaign_id: this.campaignId,
        id: this.campaignEventId,
        fullAddress: null,
      }
    }
  },
  components: {
    // Datetime,
    // VueGoogleAutocomplete,
  },
  created() {
    if (this.campaignEventId){
      axios.get('/campaign-event/' + this.campaignEventId)
          .then(response => {
            // console.log(response.data)
            this.form = response.data
            if (this.form.end_date){
              this.day_selection = 'multiple'
            }
          })

      this.form.is_new = false
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },
    createOrUpdate() {
      if (!this.form.begins_at){
        this.$notify({
          text: 'Start date is required',
          type: 'error',
        })
        return
      }
      if (!this.form.address){
        this.$notify({
          text: 'Address is required',
          type: 'error',
        })
        return
      }
      if (!this.form.title){
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      axios.post('/campaign-event/create', this.form)
          .then(response => {
            // console.log(response.data)
            this.$notify({
              text: 'Campaign event successfully ' + this.action(),
              type: 'success',
            })

            window.location.href = '/campaign/'+this.campaignId+'/event'
          })
    },
    action() {
      return this.campaignEventId ? 'updated' : 'created'
    },
    getAddressData: function (addressData, placeResultData, id) {
      //console.log('got here')
      this.form.address = addressData.street_number + ' ' + addressData.route
      this.form.city = addressData.locality
      this.form.state = addressData.administrative_area_level_1
      this.form.zip = addressData.postal_code
    },

    resetAddressOnKeyPress: function (changes) {
      //console.log(changes)
    },
    eventsUrl() {
      return '/campaign/'+this.campaignId+'/event/'
    }
  }
}
</script>
